import React from 'react'
import EditModal from '../edit-modal'
import useClientLocation from '../../../hooks/use-client-location'

const ExperienceEditScreen = () => {
    const { goBack, params } = useClientLocation()
    const experienceId = params.experienceId
    return (
        <EditModal
            experienceId={experienceId !== 'new' ? experienceId : undefined}
            onClose={goBack}
        />
    )
}

export default ExperienceEditScreen